import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RoomsComponent } from './containers/rooms/rooms.component';
import { RestaurantComponent } from './containers/restaurant/restaurant.component';
import { RoomDetailComponent } from './containers/room-detail/room-detail.component';
import { AuthGuard } from '../services/auth.guard';
import { BookingListComponent } from './containers/booking-list/booking-list.component';
import { BookingShellComponent } from './containers/booking-shell/booking-shell.component';
import { AddBookingComponent } from './containers/add-booking/add-booking.component';
import { EditBookingComponent } from './containers/edit-booking/edit-booking.component';
import { PersonalinfoComponent } from './form-components/personalinfo/personalinfo.component';
import { ConferenceinfoComponent } from './form-components/conferenceinfo/conferenceinfo.component';
import { AccomodationinfoComponent } from './form-components/accomodationinfo/accomodationinfo.component';
import { RoomchoiceComponent } from './form-components/roomchoice/roomchoice.component';
import { ConfirmationComponent } from './form-components/confirmation/confirmation.component';
import { TourinfoComponent } from './form-components/tourinfo/tourinfo.component';
import { AddBookingGuard } from './services/add-booking.guard';
import { ViewBookingComponent } from './containers/view-booking/view-booking.component';

const routes: Routes = [
  {
    path: 'bookings',
    component: BookingShellComponent,
    // canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: BookingListComponent
      },
      {
        path: 'add',
        component: AddBookingComponent,
        children: [
          {
            path: '',
            redirectTo: 'personal-info',
            pathMatch: 'prefix',
            canActivate: [AddBookingGuard]
          },
          {
            path: 'personal-info',
            component: PersonalinfoComponent,
            canActivate: [AddBookingGuard]
          },
          {
            path: 'conference-info',
            component: ConferenceinfoComponent,
            canActivate: [AddBookingGuard]
          },
          {
            path: 'accommodation-info',
            component: AccomodationinfoComponent,
            canActivate: [AddBookingGuard]
          },
          {
            path: 'room-choice',
            component: RoomchoiceComponent,
            canActivate: [AddBookingGuard]
          },
          {
            path: 'tour-info',
            component: TourinfoComponent,
            canActivate: [AddBookingGuard]
          },
          {
            path: 'confirmation',
            component: ConfirmationComponent,
            canActivate: [AddBookingGuard]
          }
        ]
      },
      {
        path: ':id/edit',
        component: EditBookingComponent
      },
      {
        path: ':id/view',
        component: ViewBookingComponent
      }
    ]
  },
  {
    path: 'hotels',
    children: [
      {
        path: '',
        component: RoomsComponent
      },
      {
        path: ':id',
        children: [
          {
            path: '',
            component: RoomDetailComponent
          }
        ]
      }
    ]
  },
  {
    path: 'restaurant',
    component: RestaurantComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BookingRoutingModule {}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/booking/booking.routing.ts